import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToolsService } from '../../../services/tools/tools.service';
import { PanierService } from '../../../services/manage/panier/panier.service';
import * as moment from 'moment';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';
import { DeviceCheck } from 'src/app/services/api/DeviceCheck/DeviceCheck.service';
import { TranslateService } from '@ngx-translate/core';
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";

declare var paypal: any;
declare var Stripe: any;

@Component({
  selector: 'app-confirmorder',
  templateUrl: './confirmorder.component.html',
  styleUrls: ['./confirmorder.component.css']
})

export class ConfirmorderComponent implements OnInit {

  @ViewChild('paypal') paypalElement: ElementRef | any;

  stripe: any;

  orderInfos: any;

  delivryAddress: any;
  billingAddress: any;
  relay: any

  orderCard: any;
  orderPan: any;

  dateOrder: any;
  hourOrder: any;

  currSM: any;

  // Use Therms checkbox
  salesTerms: boolean | any;

  // Basket infos
  totalPrice: number | any;
  allTotal: number | any;
  shippingPrice: number | any;
  deliveryPrice: number | any;

  // Error mesage
  errorMessage: string | any;

  // Loader
  loader: boolean = false;
  loaderMessage: string | any;

  innerHeight: number = window.innerHeight;
  merchantClient: any;
  cardNeeded: boolean | any;
  interval: any = null;
  time = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ConfirmorderComponent>,
    private tools: ToolsService,
    private panMan: PanierService,
    private orderApi: ClientOrdersService,
    private addressApi: ClientaddressesService,
    private stripeApi: MyStripeService,

    private DeviceCheck: DeviceCheck,
    public translate: TranslateService
  ) {
    this.orderCard = data.card;
    this.billingAddress = data.billingAddress;
    this.delivryAddress = data.delivryAddress;
    this.relay = data.relay;
    this.merchantClient = data.merchantClient

  }

  ngOnInit() {

    this.initDatas();
  }

  /**
   * @description Initialise toutes les données
   * @returns {void}
   */
  initDatas(): void {

    this.orderInfos = this.tools.getStor("infos_note");
    this.orderPan = this.tools.getStor(PanierService.TAG_STORAGE);
    this.orderInfos = this.tools.getStor("infos_note");
    this.currSM = this.tools.getStor(SalemethodService.TAG_STORAGE);
    this.dateOrder = moment(this.tools.getStor("date_order")).format("YYYY-MM-DD");
    this.hourOrder = moment(this.tools.getStor("hour_order")).format("HH:mm");
    this.allTotal = this.panMan.getPanInfos("allship");
    this.totalPrice = this.panMan.getPrice();
    this.shippingPrice = this.addressApi.getShippingPrice(this.orderPan, this.relay, 1);
    this.deliveryPrice = this.panMan.getPanInfos("delivery");
    this.cardNeeded = (this.currSM.payment_type === "online" || this.currSM.payment_type === "secure_counter") ? true : false;

    /**
     * Initialise Stripe
     */

    if (this.cardNeeded) {

      this.stripeApi.getStripeKey().subscribe(async key => {
        if (key) {
          let pos: any = this.tools.getStor("point_of_sale");
          this.stripe = Stripe(key, { stripeAccount: pos.stripe_account });
          // this.stripe = await loadStripe(key);
        }
      });
    }

    /**
     * Initialise Paypal
     */
    if (this.currSM.payment_type === "online_paypal" || this.currSM.payment_type === "secure_counter_paypal") {
      setTimeout(() => {
        this.initPaypal();
      });
    }

    /**
     * Initialise Payzen
     */

  }

  /**
   * @description Créer une commande (Stripe, paiement au comptoir)
   * @param {any} payment_intent_id
   * @returns {void}
   */
  submitOrder(payment_intent_id?: any, order_id_device?: any): void {

    const that = this;
    that.loader = true;
    that.dialogRef.disableClose = true;

    that.orderApi.submitOrder(true,that.orderCard, that.billingAddress, that.delivryAddress, that.relay, null, payment_intent_id, this.merchantClient, null, order_id_device).then(

      data => {


        /**
         * Success
         */
        if (data.code === 0) {

          that.orderApi.endOrder(data.order_id);
          that.dialogRef.close();


        }

        /**
          * Stripe SCA
         */
        else if (data.code === -2) {
          this.tools.setStor("ClientKeyPayIntenCard",data.pi);
          that.stripe.handleCardAction(

            data.payment_intent_client_secret

          ).then(function (result: any) {

            if (result.error) {

              that.errorMessage = result.error.message;
              that.loader = false;
              that.dialogRef.disableClose = false;

            } else {

              that.confirmOrderStripe(result.paymentIntent.id);

            }

          });

        }



        /**
         * Erreur
         */
        else {

          that.loader = false;
          that.dialogRef.disableClose = false;
          that.errorMessage = data.message;

        }

      }

    );

  }

  /**
     * @description Créer une commande (Paypal)
     * @param {any} paypal_order_id
     * @returns {Promise}
     */
  submitPaypalOrder(paypal_order_id?: any, order_id_device?: any): Promise<any> {

    return new Promise((resolve, reject) => {

      const that = this;
      that.loader = true;
      that.dialogRef.disableClose = true;

      that.orderApi.submitOrder(true,that.orderCard, that.billingAddress, that.delivryAddress, that.relay, paypal_order_id, null, this.merchantClient, null, order_id_device).then(

        data => {

          /**
           * Success
           */
          if (data.code === 0) {

            that.orderApi.endOrder(data.order_id);
            that.dialogRef.close();

          }

          /**
            * Paypal order creation
           */
          else if (data.code === -3) {

            resolve(data.paypal_order);

          }



          /**
           * Erreur
           */
          else {

            that.loader = false;
            that.dialogRef.disableClose = false;
            that.errorMessage = data.message;

            reject();

          }

        }

      );

    })

  }

  /**
   * @description Initialise et configure stripe
   * @returns {void}
  */
  initPaypal(): void {

    const that = this;

    paypal.Buttons(
      {
        commit: true,
        style: {
          height: 40,
          layout: 'horizontal',
          tagline: false,
          size: 'responsive',
          color: 'gold',
          shape: 'rect',
          label: 'paypal',
        },

        createOrder: function (data: any, actions: any) {
          return that.submitPaypalOrder().then(data => {
            return data;
          }).then(orderData => {
            return orderData.id
          })
        },
        onApprove: function (data: any, actions: any) {
          that.submitPaypalOrder(data.orderID);
        },

        onClick: () => {
          if (this.salesTerms) {
            this.errorMessage = null;
            return true;
          } else {

            this.errorMessage = this.translate.instant('confirmOrderComponent.confirmconditions');
            return false;
          }
        },

        onCancel: function (data: any, actions: any) {
          that.loader = false;
        }

      }
    ).render(this.paypalElement.nativeElement);
  }

  confirmOrderStripe(payment_intent_id?: string) {
    this.submitOrder(payment_intent_id);
  }

  closeDial() {
    this.dialogRef.close();
  }




  goTerms(): void {

    const merchantName: any = this.tools.getStor("url_encode");
    const pointOfSale: any = this.tools.getStor("point_of_sale");
    window.open(window.location.origin + "/merchantTerms" + "/" + merchantName + "/" + pointOfSale.id_webshop, "_blank");

  }




  /***************
    * Device Check
     ************/


  timerSetOrderIntent(data: any, paypal?: any) {
    this.time = 5;

    this.interval = setInterval(() => {
      if (this.time > 0) {
        this.time -= 1;
      }

      if (this.time == 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.loader = false;
      }
      if (this.interval)
        this.getStatusOrderIntent(data, paypal);
    }, 1000);
  }

  getStatusOrderIntent(data: any, paypal?: any) {
    this.DeviceCheck.getStatusOrderIntent(data).then(value => {

      if (value.order_intent.status == 1) {
        //on stop le timer
        this.time = 0;
        // //on continue
        paypal ? this.submitPaypalOrder(null, data.order_id_device) :
          this.submitOrder(null, data.order_id_device);
        // this.orderApi.endOrder(data.order_id);
      }
    }).catch(err => {
      this.loader = false;
      console.error('err', err)
    })
  }
}
